// extracted by mini-css-extract-plugin
export var defaultWrapper = "_n5-3";
export var downloadButton = "_n5-4";
export var fileContainer = "_n5-9 _n5-7";
export var fileContainerBase = "_n5-7";
export var fileContainerFixedHeight = "_n5-8 _n5-7";
export var fileInfo = "_n5-5";
export var fileInfoWidthRestricted = "_n5-6";
export var fileType = "_n5-1";
export var fileTypeName = "_n5-2";
export var image = "_n5-0";
export var link = "_n5-b";
export var overflowEllipsis = "_n5-a";